module.exports = __webpack_public_path__ + "static/img/DOUGLAS-COCHRANE.f825017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DOUGLAS-COCHRANE.jpg
// module id = SSZp
// module chunks = 0